<template>
  <div class="form-wrapper">

    <div v-if="error" class="error">{{error}}</div>

    <div v-if="!relationship.create">
      <h3>{{edit.tag_name}}</h3>
      <small><b>Category:</b> {{edit.category_name}}</small>
    </div>
    

    <form class="form form--sidepanel">

      <h4>Parent</h4>
      <div class="row">
        <div class="flex-2">
          <div class="form-group">
            <label for="">Category</label>
            <input-select
              name="parent_tag_category_id"
              ref="parent_tag_category_id"
              :selectedValue="edit.parent_tag_category_id"
              :searchable="true"
              :options="getOrganizationCategory"
              :onChange="onChangeParentCategory"
            />
          </div>
          <div class="form-group">
            <label for="">{{ $tc('tag.labels.tag', 1) }}</label>
            <input-select
              :key="counter2"
              name="parent_tag_id"
              ref="parent_tag_id"
              :selectedValue="edit.parent_tag_id"
              :searchable="true"
              :options="parentTags.map(t => ({ value: t.id, label: t.name }))"
              :onChange="onChangeParentTag"
              :onSearchChange="(searchText) =>onSearchChange(searchText, edit.parent_tag_category_id, 1)"
              :loading="projectCategorySetupIsLoading && this.loadingElement == 1"
            />
          </div>
        </div>
      </div>

      <div v-if="relationship.create">
        <h4>{{ $tc('tag.labels.tagChild', 1) }}</h4>
        <div class="form form--sidepanel">
          <div class="row">
            <div class="flex-2">
              <div class="form-group">
                <label for="">Category</label>
                <input-select
                  name="category_id"
                  ref="category_id"
                  :selectedValue="edit.category_id"
                  :searchable="true"
                  :options="categories.map(c => ({ value: c.id, label: c.name }))"
                  :onChange="onChangeSelfCategory"
                />
              </div>
              <div class="form-group">
                <label for="">{{ $tc('tag.labels.tag', 1) }}</label>
                <input-select
                  :key="counter"
                  name="tag_id"
                  ref="tag_id"
                  :selectedValue="edit.tags"
                  :searchable="true"
                  :options="selfTags.map(t => ({ value: t.id, label: t.name }))"
                  :onChange="onChangeSelfTag"
                  :multiple="!isEdit"
                  :onSearchChange="(searchText) => onSearchChange(searchText, edit.category_id, 2)"
                  :loading="projectCategorySetupIsLoading && loadingElement == 2"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!edit.create">
        <h4>Children</h4>
        <div v-if="edit.child_tags.length > 0" class="child-tags">
          <div class="row" v-for="child_tag in edit.child_tags" :key="child_tag.temp_id">
            <div class="flex-2">
              <div class="form-group">
                <label for="">Category</label>
                <input-select
                  name="child_category_id"
                  ref="child_category_id"
                  :selectedValue="child_tag.category_id"
                  :searchable="true"
                  :options="findChildCategory(child_tag.temp_id)"
                  :onChange="(value) => onChangeChildCategory(child_tag.temp_id, value)"
                />
              </div>
              <div class="form-group">
                <label for="">{{ $tc('tag.labels.tag', 1) }}</label>
                <input-select
                  name="child_tag_id"
                  ref="child_tag_id"
                  :selectedValue="child_tag.id"
                  :searchable="true"
                  :options="findTags(child_tag)"
                  :onChange="(value) => onChangeChildTag(child_tag, value)"
                  :multiple="!isEdit"
                  :onSearchChange="(searchText) => onSearchChange(searchText, child_tag.category_id, 3)"
                  :loading="projectCategorySetupIsLoading && loadingElement == 3"
                />
              </div>
            </div>
            <span v-if="!isEdit" class="remove" @click="() => onRemoveChild(child_tag.temp_id)">
              <i class="fas fa-times"></i>
            </span>
          </div>
        </div>
        <div v-else class="empty-state">
          This tag has no child tags.
        </div>
      </div>
      <div class="btn-container">
        <button
          class="btn btn-carma btn-sm"
          @click.prevent="saveChanges"
        >
          <i class="fas fa-check"></i> Save
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import _ from 'lodash';
import InputSelect from '../form-components/input-select';
import { mapState, mapActions } from "vuex";
import array from '@/helpers/array';
import FormHelper from '@/helpers/form';

export default {
  props: {
    relationshipType: String,
    relationship: Object,
    hierarchies: Array,
    categories: Array,
    onSave: Function,
    general: Object,
    isEdit: Boolean,
    onRemove: Function
  },

  data: function() {
    const edit = _.cloneDeep(this.relationship);
    return {
      error: '',
      edit,
      counter: 0,
      counter2: 0,
      globalTimeout: null,
      loadingElement: null
    }
  },

  computed: {
    ...mapState({
      projectCategorySetupIsLoading: state => state.projectSetup?.projectCategorySetup?.isBusy,
      projectSetupGeneral: state => state?.projectSetup?.projectSetup?.data?.general
    }),
    selfTags: function() {
      let tags = [];
      const category = this.categories.find(c => c.id == this.edit.category_id);

      if (category) {
        tags = category.tags?.filter(t => t?.id);

        if (this.edit.parent_tag_id)  {
          tags = tags.filter(t => t.id != this.edit.parent_tag_id);
        }
      }

      return _.uniqBy(tags, 'id');
    },
    parentTags: function() {
      let tags = [];
      const category = this.categories.find(c => c.id == this.edit.parent_tag_category_id);

      if (category) {
        let _tags = Array.isArray(this.edit.tags) ? this.edit.tags?.map(t => t?.id || t) : [this.edit.tags];
        // add already added tags to options
        category.tags.push({id: this.edit.parent_tag_id, name: this.edit.parent_tag_name});
        tags = category.tags?.filter(t => t != null && !_tags?.includes(t?.id));
      }

      return _.uniqBy(tags, 'id');
    },
    isUseOrgWithCategory() { return this.projectSetupGeneral?.organizations_with_category },
    getOrganizationCategory() {
      return this.categories.reduce((acc, cate) => cate?.category_type_id === 4 && (acc = [...acc, { value: cate?.id, label: cate?.name }]) && acc || acc, [])
    }
  },

  methods: {
    ...mapActions({
      "getProjectCategoriesSetup": "projectSetup/getProjectCategoriesSetup"
    }),
    onChangeSelfCategory: function(value) {
      this.edit = {
        ...this.edit,
        category_id: value,
        tag_id: null
      }
    },

    onChangeSelfTag: function(value) {
      this.edit = {
        ...this.edit,
        tags: value
      }
    },

    onChangeParentCategory: function(value) {
      this.edit = {
        ...this.edit,
        parent_tag_category_id: value,
        parent_tag_id: null
      }
    },

    onChangeParentTag: function(value) {
      this.edit = {
        ...this.edit,
        parent_tag_id: value
      }
    },

    onChangeChildCategory: function(temp_id, value) {
      this.edit = {
        ...this.edit,
        child_tags: this.edit.child_tags.map(t => {
          return t.temp_id == temp_id ? { id: null, name: null, temp_id: t.temp_id, category_id: value } : t
        })
      }
    },

    _getTagName(child_tag = {}, value){ 
      return this.categories.reduce((acc, c) => c.id == child_tag?.category_id && (acc = c?.tags?.find(t => t?.cat_id === child_tag?.category_id && value === t?.id)?.name) || acc, null)
    },

    onChangeChildTag: function(child_tag, value) {
      if(!this.isEdit ? !value?.length : !value) return value;
        let _exist = this.edit.child_tags?.find(t => t?.temp_id == child_tag?.temp_id);
        let _newTags = t => ({ ...child_tag, ...t, id: value, name: this._getTagName(child_tag, value?.find(_v => Array.isArray(_exist?.id) ? !_exist?.id?.includes(_v) : _exist?.id !== _v )) });

        this.edit = {
          ...this.edit,
          child_tags: this.isEdit ? [{ ...child_tag, id: value, name: this._getTagName(child_tag, value) }] : this.edit.child_tags.map(t => t.temp_id == child_tag.temp_id ? _newTags(t) : t)
        }
    },

    findTags: function(childTag) {
      let options = [];
      let { category_id, temp_id, id: childId } = childTag;

      if (category_id != null) {
        const alreadyPicked = this.edit.child_tags.filter(t => t.temp_id != temp_id && t.category_id == category_id).map(t => t.id)?.flat();
        const category = this.categories.find(c => c.id == category_id);

        if (category) {
          const tags = category.tags.filter(t => alreadyPicked.includes(t?.id) == false && t.id != this.edit.parent_tag_id);
          tags?.push({ id: childId, name: childTag?.name });
          options = tags.map(t => ({ value: t.id, label: t.name }));
        }
      }

      return _.uniqBy(options, 'value');
    },

    findChildCategory: function(temp_id) {
      let categories = this.categories.filter(c => {
        // Check if there's any child_tag that matches both category_id and temp_id
        let exists = this.edit?.child_tags?.some(ct => ct?.category_id === c?.id && temp_id !== ct?.temp_id);
        // Return categories that do not have a matching child_tag
        return !exists;
      });
      return categories.length ? categories.map(c => ({ value: c.id, label: c.name })) : [];
    },

    addChildTag: function() {
      const tag = { id: null, name: null, category_id: null, temp_id: this.generateTempId() };
      this.edit.child_tags.push(tag);
    },

    onEditRemove: async function(data) {
      return new Promise(async (resolve) => {
        await this.onRemove(data);
        resolve(data);
      });
    },

    handleEdit: async function(){
      let data;
      if(this.isEdit) {
          let _relationChildTagsIds = this.relationship?.child_tags.map(t => t.id);
          this.edit.tags = this.edit?.tags?.filter(t => !_relationChildTagsIds?.includes(t?.id));

          let childTag = this.relationship?.child_tags?.[0];

          if (childTag?.association_id) {
            data = {
              id: this.relationship.id,
              name: this.relationship.tag_name,
              childName: childTag?.name,
              delete_associations: [childTag?.association_id]
            }
          } else {
            data = { ...this.relationship, tags: this.edit.tags, tag_id: childTag?.id, childName: childTag?.name };
          }

          // remove old relation
          await this.onEditRemove(data);
        }
        return data;
    },

    saveChanges: async function() {
      if (this.isValid(this.edit)) {
        // if edit mode remove old tag relation and add new
        await this.handleEdit();
        if(this.isEdit){
          // prepare new tag creation props, 
          // add tag to be created in tags prop
          this.edit.tags = this.edit?.child_tags?.map(t => t?.id);
          // set create flag as on create mode
          this.edit.create = true;
        }
        this.onSave('hierarchy', this.edit);
      }
      else {
        this.errors = 'All tags must be different.';
      }
    },

    onRemoveChild: function(temp_id) {
      this.edit = {
        ...this.edit,
        child_tags: this.edit.child_tags.filter(t => t.temp_id != temp_id)
      }
    },

    isValid: function(relationship) {
      let valid = false;
      let _relationTagsIds = relationship.tags?.map(t => t?.id);
      let _relationChildTagsIds = relationship.child_tags.map(t => t.id);

      valid = _.every([
          relationship.tags != null && relationship.tags?.length,
          relationship.parent_tag_id != null,
          !relationship.tags?.find(t => t?.id === relationship.parent_tag_id),
          !this.isEdit ? !array.arrayIntersection(_relationChildTagsIds, _relationTagsIds)?.length : true,
          relationship.child_tags.map(t => t.id).includes(relationship.parent_tag_id) == false
        ]);

      return valid;
    },

    generateTempId: function() {
      return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    },
    onSearchChange(searchText, categoryId, loadingElement) {
      FormHelper.delayFunction(this.onSearch(searchText, categoryId), 500, this, loadingElement);
    },
    onSearch (searchText, parentId) {
      this.globalTimeout = null;
      if(!parentId || !this.isUseOrgWithCategory) return;
      const filters = {tag_name: searchText, cat_id: parentId};
      this.fetchProjectCategories(filters)
    },

    fetchProjectCategories(filters) {
      const pagination = { page: 1, perPage: 20, order: 'name', sort: 'asc' };
      this.getProjectCategoriesSetup({ projectUid: this.$route.params.project_uid, pagination, filters})
    }
  },

  components: {
    InputSelect
  }
}
</script>

<style lang="scss" scoped>
  .form-wrapper {
    h3 {
      margin: 0 0 5px 0;
    }

    h4 {
      border-bottom: 2px solid #ddd;
      font-size: 14px;
      font-weight: 700;
      text-transform: uppercase;
      padding-bottom: 5px;
      padding-left: 10px;
      color: #b0b6b8;
      margin-top: 20px;
    }

    .row {
      display: flex;
      align-items: center;

      .flex-2 {
        display: flex;
        align-items: flex-start;
        flex: 1 1 auto;
        margin: 0 -10px;

        .form-group {
          flex: 0 0 50%;
          padding: 0 10px;
        }
      }
    }

    .child-tags {
      .remove {
        padding: 10px 10px;
        margin-left: 20px;
        cursor: pointer;
      }
    }

    .empty-state {
      margin-bottom: 20px;
    }

    .text {
      margin: 20px 0;
    }

    .btn {
      display: inline-block;
      width: auto;
    }
  }
</style>